/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * EmptyMessage
 *
 * @file EmptyMessage.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.0
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Empty from '../../assets/image/Empty';

const styles = () => ({
  description: {
    fontfamily: 'Hind',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 'normal',
    textAlign: 'center'
  },
  emptyMessageContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px 10px',
    justifyContent: 'center',
    paddingTop: 50,
    paddingRight: 20,
    paddingLeft: 20
  },
  heading: {
    fontfamily: 'Hind',
    fontSize: 22,
    fontStyle: 'normal',
    fontWeight: 600,
    paddingBottom: 5
  },
  headingText: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  }
});

const EmptyMessage = ({
  classes,
  messageDesciption,
  messageHeading
}) => (
  <div className={classes.emptyMessageContainer}>
    <div className={classes.headingText}>
      <div className={classes.heading}>{messageHeading}</div>
      <div className={classes.description}>{messageDesciption}</div>
    </div>
    <div>
      <Empty />
    </div>
  </div>
);

EmptyMessage.propTypes = {
  classes: PropTypes.object.isRequired,
  messageDesciption: PropTypes.string,
  messageHeading: PropTypes.string
};
EmptyMessage.defaultProps = {
  messageDesciption: '',
  messageHeading: ''
};

export default memo(withStyles(styles)(EmptyMessage));
